import { useState, useEffect } from 'react';

function useIsMobile() {
    var _a = useState(true), isMobile = _a[0], setIsMobile = _a[1];
    useEffect(function () {
        var observer = new ResizeObserver(function () {
            setIsMobile(window.innerWidth < 768);
        });
        observer.observe(document.body);
        return function () {
            observer.disconnect();
        };
    }, []);
    if (typeof window === 'undefined')
        return true;
    return isMobile;
}

export { useIsMobile };
//# sourceMappingURL=isMobile.util.js.map
